import Image from "next/image";
import React from "react";
import Link from "next/link";
import { twMerge } from "tailwind-merge";
import { SupText } from "@repo/core-ui";
import { SupMint, SupProtocol, SupVault } from "@repo/core-ui";

import { MenuItem } from "@/components/MobileLayout/Menu/MenuItem";

import { MenuDrawer, type MenuDrawerProps } from "./Base";

export function BrowseDrawer(props: Omit<MenuDrawerProps, "children">) {
  return (
    <MenuDrawer {...props} contentClassName={twMerge("flex flex-col justify-end", props.contentClassName)}>
      <SupText variant="button" weight="bold" className="px-4 py-2 text-neutral-700">
        Earn
      </SupText>

      <nav className="flex flex-col">
        <Link href="/" onClick={props.onClose}>
          <MenuItem icon={<SupMint className="size-6" />} title="Explore" />
        </Link>
        <Link href="/vaults/" onClick={props.onClose}>
          <MenuItem icon={<SupVault className="size-6" />} title="Vaults" />
        </Link>
        <Link href="/protocols/" onClick={props.onClose}>
          <MenuItem icon={<SupProtocol className="size-6" />} title="Protocols" />
        </Link>
        <Link href="/piggy/claim/" onClick={props.onClose}>
          <MenuItem icon={<Image src="/assets/img/claim/piggy-token.svg" alt="Piggy Icon" width={24} height={24} />} title="$PIGGY" />
        </Link>
      </nav>
    </MenuDrawer>
  );
}
